import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, createBlock as _createBlock, withCtx as _withCtx, toDisplayString as _toDisplayString, createStaticVNode as _createStaticVNode, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "app__body" }
const _hoisted_2 = { class: "app__content" }
const _hoisted_3 = {
  key: 0,
  class: "main-loader"
}
const _hoisted_4 = /*#__PURE__*/_createElementVNode("i", { class: "main-loader__svg" }, null, -1)
const _hoisted_5 = ["src"]
const _hoisted_6 = { class: "container" }
const _hoisted_7 = { class: "app__payment-and-delivery" }
const _hoisted_8 = { class: "app__payment-and-delivery-container" }
const _hoisted_9 = {
  class: "app__payment-and-delivery-top",
  "data-block": "delivery"
}
const _hoisted_10 = /*#__PURE__*/_createElementVNode("div", { class: "app__payment-and-delivery-top-left" }, [
  /*#__PURE__*/_createElementVNode("h2", { class: "app__payment-and-delivery-title" }, "Оплата и доставка"),
  /*#__PURE__*/_createElementVNode("div", { class: "app__payment-and-delivery-description" }, [
    /*#__PURE__*/_createElementVNode("p", null, " Премиальные стейки из мраморной говядины Labinsk beef заслуженно пользуются спросом, их вкус высоко оценен постоянными клиентами нашей компании. "),
    /*#__PURE__*/_createElementVNode("p", null, " Купить стейки и отруба из мраморной говядины напрямую от производителя вы можете на нашем сайте, минимальный срок выполнения заказа - 3 дня. ")
  ])
], -1)
const _hoisted_11 = { class: "app__payment-and-delivery-top-right" }
const _hoisted_12 = { class: "app__payment-and-delivery-list" }
const _hoisted_13 = /*#__PURE__*/_createElementVNode("div", { class: "app__payment-and-delivery-item-title" }, " Сколько стоит доставка? ", -1)
const _hoisted_14 = /*#__PURE__*/_createElementVNode("div", { class: "app__payment-and-delivery-item-text" }, " Доставка осуществляется бесплатно. ", -1)
const _hoisted_15 = /*#__PURE__*/_createElementVNode("span", { class: "app__payment-and-delivery-svg" }, null, -1)
const _hoisted_16 = [
  _hoisted_13,
  _hoisted_14,
  _hoisted_15
]
const _hoisted_17 = /*#__PURE__*/_createElementVNode("div", { class: "app__payment-and-delivery-item-title" }, " Могу ли я оплатить заказ наличными? ", -1)
const _hoisted_18 = /*#__PURE__*/_createElementVNode("div", { class: "app__payment-and-delivery-item-text" }, " Нет, оплата осуществляется только с банковской карты при оформлении заказа. ", -1)
const _hoisted_19 = /*#__PURE__*/_createElementVNode("span", { class: "app__payment-and-delivery-svg" }, null, -1)
const _hoisted_20 = [
  _hoisted_17,
  _hoisted_18,
  _hoisted_19
]
const _hoisted_21 = /*#__PURE__*/_createElementVNode("div", { class: "app__payment-and-delivery-item-title" }, " Как узнать статус моего заказа? ", -1)
const _hoisted_22 = /*#__PURE__*/_createElementVNode("div", { class: "app__payment-and-delivery-item-text" }, " Связаться с нами по номеру телефона горячей линии 8-800-250-8-925 и мы в кратчайшие сроки решим ваш вопрос. ", -1)
const _hoisted_23 = /*#__PURE__*/_createElementVNode("span", { class: "app__payment-and-delivery-svg" }, null, -1)
const _hoisted_24 = [
  _hoisted_21,
  _hoisted_22,
  _hoisted_23
]
const _hoisted_25 = {
  class: "app__payment-and-delivery-bottom",
  "data-block": "about"
}
const _hoisted_26 = { class: "app__payment-and-delivery-bottom-left" }
const _hoisted_27 = { class: "app__payment-and-delivery-bottom-left-container" }
const _hoisted_28 = /*#__PURE__*/_createElementVNode("div", { class: "app__payment-and-delivery-bottom-title" }, " О компании ", -1)
const _hoisted_29 = /*#__PURE__*/_createElementVNode("p", null, " Labinsk Beef - это не просто производство мраморной говядины, это цитадель качества и вкуса. ", -1)
const _hoisted_30 = /*#__PURE__*/_createElementVNode("p", null, " Мы выращиваем бычков абердин-ангусской породы под Кубанским солнцем на экологически чистых полях и создаём премиальную мраморную говядину. Сочную. Мягкую. Бесподобно вкусную. ", -1)
const _hoisted_31 = /*#__PURE__*/_createElementVNode("p", null, " Полученное мясо созревает несколько недель в специальной камере. Именно тогда отчетливо проявляется характерный мраморный рисунок, а мясо становится более нежным. Во время тепловой обработки жировые прослойки тают, стейк наполняется соком и приобретает ту самую неповторимую мягкость и нежность, которая так ценится гурманами во всем мире. ", -1)
const _hoisted_32 = /*#__PURE__*/_createElementVNode("p", null, [
  /*#__PURE__*/_createTextVNode(" В нашем ассортименте вы найдете:"),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode(" Вырезка Striploin, стейк Ribeye, антрекоты, ромштекс, стейк Osso buco, отрубы мраморной говядины разной степени мраморности и всеми обожаемый стейк Fillet mignon. ")
], -1)
const _hoisted_33 = /*#__PURE__*/_createElementVNode("p", null, " У нас собственные фермерские хозяйства и особая система вызревания мяса. Именно поэтому, попробовав продукт нашего производства один раз, вы наверняка останетесь нашим постоянным клиентом. ", -1)
const _hoisted_34 = {
  key: 0,
  class: "app__payment-and-delivery-bottom-list"
}
const _hoisted_35 = /*#__PURE__*/_createStaticVNode("<li class=\"app__payment-and-delivery-bottom-item app__payment-and-delivery-bottom-item--active\"> Адлер </li><li class=\"app__payment-and-delivery-bottom-item\">Анапа</li><li class=\"app__payment-and-delivery-bottom-item\">Выселки</li><li class=\"app__payment-and-delivery-bottom-item\"> Геленджик </li><li class=\"app__payment-and-delivery-bottom-item\"> Краснодар </li><li class=\"app__payment-and-delivery-bottom-item\">Майкоп</li><li class=\"app__payment-and-delivery-bottom-item\"> Новороссийск </li><li class=\"app__payment-and-delivery-bottom-item\"> Пятигорск </li><li class=\"app__payment-and-delivery-bottom-item\"> Ростов-на-Дону </li><li class=\"app__payment-and-delivery-bottom-item\">Сочи</li><li class=\"app__payment-and-delivery-bottom-item\"> Ставрополь </li><li class=\"app__payment-and-delivery-bottom-item\">Шахты</li>", 12)
const _hoisted_47 = [
  _hoisted_35
]
const _hoisted_48 = { class: "app__payment-and-delivery-bottom-right" }
const _hoisted_49 = ["src"]
const _hoisted_50 = /*#__PURE__*/_createElementVNode("div", { class: "" }, null, -1)
const _hoisted_51 = { class: "btn-basket__container" }
const _hoisted_52 = /*#__PURE__*/_createElementVNode("i", { class: "btn-basket__svg" }, null, -1)
const _hoisted_53 = {
  key: 0,
  class: "btn-basket__count"
}
const _hoisted_54 = { class: "btn-basket__text" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_TheHeader = _resolveComponent("TheHeader")!
  const _component_Main_swiper = _resolveComponent("Main_swiper")!
  const _component_CatalogList = _resolveComponent("CatalogList")!
  const _component_RecipeList = _resolveComponent("RecipeList")!
  const _component_TheBeef = _resolveComponent("TheBeef")!
  const _component_CatalogItemDetail = _resolveComponent("CatalogItemDetail")!
  const _component_v_dialog = _resolveComponent("v-dialog")!
  const _component_RecipeItemDetail = _resolveComponent("RecipeItemDetail")!
  const _component_v_layout = _resolveComponent("v-layout")!
  const _component_TheFooter = _resolveComponent("TheFooter")!
  const _component_modals_container = _resolveComponent("modals-container")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        (_ctx.loading)
          ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
              _hoisted_4,
              _createElementVNode("img", {
                class: "main-loader__gif",
                src: require('@/assets/img/main-loader-gif.gif'),
                alt: "Map"
              }, null, 8, _hoisted_5)
            ]))
          : _createCommentVNode("", true),
        _createVNode(_component_TheHeader, {
          onOpenAccount: _ctx.openAccount,
          onOpenHistory: _ctx.openHistory
        }, null, 8, ["onOpenAccount", "onOpenHistory"]),
        _createVNode(_component_Main_swiper),
        _createVNode(_component_CatalogList, { catalog: _ctx.catalog }, null, 8, ["catalog"]),
        _createVNode(_component_RecipeList),
        _createElementVNode("div", _hoisted_6, [
          _createVNode(_component_TheBeef)
        ]),
        _createElementVNode("div", _hoisted_7, [
          _createElementVNode("div", _hoisted_8, [
            _createElementVNode("div", _hoisted_9, [
              _hoisted_10,
              _createElementVNode("div", _hoisted_11, [
                _createElementVNode("ul", _hoisted_12, [
                  _createElementVNode("li", {
                    class: "app__payment-and-delivery-item",
                    onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.openText && _ctx.openText(...args)))
                  }, _hoisted_16),
                  _createElementVNode("li", {
                    class: "app__payment-and-delivery-item",
                    onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.openText && _ctx.openText(...args)))
                  }, _hoisted_20),
                  _createElementVNode("li", {
                    class: "app__payment-and-delivery-item",
                    onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.openText && _ctx.openText(...args)))
                  }, _hoisted_24)
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_25, [
              _createElementVNode("div", _hoisted_26, [
                _createElementVNode("div", _hoisted_27, [
                  _hoisted_28,
                  _hoisted_29,
                  _hoisted_30,
                  _hoisted_31,
                  _hoisted_32,
                  _hoisted_33,
                  false
                    ? (_openBlock(), _createElementBlock("ul", _hoisted_34, _hoisted_47))
                    : _createCommentVNode("", true)
                ])
              ]),
              _createElementVNode("div", _hoisted_48, [
                _createElementVNode("img", {
                  src: require('@/assets/img/map.png'),
                  alt: "Map"
                }, null, 8, _hoisted_49)
              ])
            ])
          ])
        ]),
        _hoisted_50
      ]),
      _createVNode(_component_v_layout, null, {
        default: _withCtx(() => [
          _createVNode(_component_v_dialog, {
            ref: "infoPopup",
            modelValue: _ctx.drawer.product.display,
            "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.drawer.product.display) = $event)),
            contentClass: "app__info-popup",
            width: "1584px"
          }, {
            default: _withCtx(() => [
              (_ctx.drawer.product.display)
                ? (_openBlock(), _createBlock(_component_CatalogItemDetail, {
                    key: 0,
                    item: _ctx.drawer.product.data
                  }, null, 8, ["item"]))
                : _createCommentVNode("", true)
            ]),
            _: 1
          }, 8, ["modelValue"]),
          _createVNode(_component_v_dialog, {
            ref: "openRecipes",
            modelValue: _ctx.drawer.recipe.display,
            "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.drawer.recipe.display) = $event)),
            class: "app__recipe-popup",
            width: "1584px"
          }, {
            default: _withCtx(() => [
              (_ctx.drawer.recipe.display)
                ? (_openBlock(), _createBlock(_component_RecipeItemDetail, {
                    key: 0,
                    item: _ctx.drawer.recipe.data
                  }, null, 8, ["item"]))
                : _createCommentVNode("", true)
            ]),
            _: 1
          }, 8, ["modelValue"])
        ]),
        _: 1
      }),
      ((_ctx.basket && _ctx.basket.items.length > 0) || true)
        ? (_openBlock(), _createElementBlock("div", {
            key: 0,
            onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.showBasket())),
            class: "btn-basket"
          }, [
            _createElementVNode("div", _hoisted_51, [
              _hoisted_52,
              false
                ? (_openBlock(), _createElementBlock("div", _hoisted_53, _toDisplayString(_ctx.basket.items.length), 1))
                : _createCommentVNode("", true)
            ]),
            _createElementVNode("div", _hoisted_54, _toDisplayString(_ctx.priceFormat(_ctx.basket.total.price)), 1)
          ]))
        : _createCommentVNode("", true),
      _createVNode(_component_TheFooter)
    ]),
    _createVNode(_component_modals_container)
  ], 64))
}